import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import NavigationBar from 'components/Navigation';
import * as S from './ChangePassword.styled';
import { memberService } from 'services/memberService';
import viewIcon from 'assets/SignupImage/view.png';

function ChangePassword() {
  const navigate = useNavigate();
  const [oldPassword, setOldPassword] = useState<string>('');
  const [newPassword, setNewPassword] = useState<string>('');
  const [newPasswordConfirm, setNewPasswordConfirm] = useState<string>('');
  const [showOldPassword, setShowOldPassword] = useState<boolean>(false);
  const [showNewPassword, setShowNewPassword] = useState<boolean>(false);
  const [showNewPasswordConfirm, setShowNewPasswordConfirm] = useState<boolean>(false);
  const [isUpdating, setIsUpdating] = useState<boolean>(false);

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleConfirm = async () => {
    if (!oldPassword) {
      alert('현재 비밀번호를 입력해주세요.');
      return;
    }

    if (!newPassword) {
      alert('새 비밀번호를 입력해주세요.');
      return;
    }

    if (!newPasswordConfirm) {
      alert('새 비밀번호 확인을 입력해주세요.');
      return;
    }

    if (newPassword !== newPasswordConfirm) {
      alert('새 비밀번호가 일치하지 않습니다.');
      return;
    }

    // 비밀번호 형식 검증
    const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d!@#$%&*]{8,15}$/;
    if (!passwordRegex.test(newPassword)) {
      alert('비밀번호는 영문과 숫자를 포함하여 7~15자로 입력해주세요.');
      return;
    }

    setIsUpdating(true);
    try {
      await memberService.updatePassword(oldPassword, newPassword);
      navigate('/change-password-complete');
    } catch (error) {
      console.error('비밀번호 변경 실패:', error);
      alert('비밀번호 변경에 실패했습니다. 현재 비밀번호를 확인해주세요.');
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    <S.Body>
      <S.Header>
        <S.BackButton onClick={handleGoBack}>
          <FontAwesomeIcon icon={faChevronLeft} />
        </S.BackButton>
        비밀번호 변경
      </S.Header>

      <S.ContentWrap>
        <S.Label>현재 비밀번호</S.Label>
        <S.InputContainer>
          <S.Input
            type={showOldPassword ? "text" : "password"}
            placeholder="현재 비밀번호를 입력해주세요"
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
          />
          <S.PasswordToggleButton
            type="button"
            onClick={() => setShowOldPassword(!showOldPassword)}
          >
            <S.PasswordToggleIcon src={viewIcon} alt="비밀번호 보기" />
          </S.PasswordToggleButton>
        </S.InputContainer>

        <S.Label>새 비밀번호</S.Label>
        <S.InputContainer>
          <S.Input
            type={showNewPassword ? "text" : "password"}
            placeholder="영문, 숫자 포함 7~15자리"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
          <S.PasswordToggleButton
            type="button"
            onClick={() => setShowNewPassword(!showNewPassword)}
          >
            <S.PasswordToggleIcon src={viewIcon} alt="비밀번호 보기" />
          </S.PasswordToggleButton>
        </S.InputContainer>

        <S.InputContainer style={{ marginTop: '8px' }}>
          <S.Input
            type={showNewPasswordConfirm ? "text" : "password"}
            placeholder="비밀번호를 다시 입력해주세요"
            value={newPasswordConfirm}
            onChange={(e) => setNewPasswordConfirm(e.target.value)}
          />
          <S.PasswordToggleButton
            type="button"
            onClick={() => setShowNewPasswordConfirm(!showNewPasswordConfirm)}
          >
            <S.PasswordToggleIcon src={viewIcon} alt="비밀번호 보기" />
          </S.PasswordToggleButton>
        </S.InputContainer>

        {newPasswordConfirm && newPassword !== newPasswordConfirm && (
          <S.ErrorText>비밀번호가 일치하지 않습니다.</S.ErrorText>
        )}

        <S.HelperText>
          영문과 숫자를 조합하여 7~15자의 비밀번호를 입력해주세요.<br />
          특수문자(!, @, #, $, % , &, *) 가능
        </S.HelperText>
      </S.ContentWrap>

      <S.BottomButton onClick={handleConfirm} disabled={isUpdating}>
        {isUpdating ? '변경 중...' : '확인'}
      </S.BottomButton>

      <NavigationBar />
    </S.Body>
  );
}

export default ChangePassword;
